<div>
  @if (label) {
    <span class="label">{{ label }}</span>
  }
  <div
    #t="matMenuTrigger"
    [matMenuTriggerFor]="color_menu"
    class="color-swatch-button"
    [ngStyle]="{ '--color': input }"
  ></div>
  <mat-menu #color_menu="matMenu">
    <div class="color-swatch-container">
      @for (color of colors; track color) {
        <div
          class="color-swatch"
          [ngClass]="{
            selected: input === color,
          }"
          [ngStyle]="{ 'background-color': color }"
          (click)="onchange(color)"
        >
          @if (input === color) {
            <div class="checkmark-wrapper">
              <div class="checkmark">
                <svg width="12" height="12" viewBox="0 0 1792 1792">
                  <path
                    d="M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z"
                    class="checkmark-path"
                  ></path>
                </svg>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </mat-menu>
</div>
